export const PUBLIC_ROUTE = {
  LANDING: '/',
  SIGN_IN: '/signin',
  EMAIL_VERIFICATION_ARABIC: '/email-verification-ar',
  EMAIL_VERIFICATION_ENGLISH: '/email-verification-en',
  VERIFY_EMAIL_ENGLISH: '/verify-email-en',
  VERIFY_EMAIL_ARABIC: '/verify-email-ar',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  RESET_CODE: '/forgot-password/reset-code',
};

export const PRIVATE_ROUTE = {
  DASHBOARD: '/'
};
